import { createRouter, createWebHistory } from 'vue-router';

// 路由参数配置
const router = createRouter({
    history: createWebHistory(), // 这里必须是history模式 其他模式会导致后面打包生成的静态文件内容都是一样的，不能起到预渲染的作用
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import('@/pages/home.vue')  //路由懒加载写法
        }, {
            path: '/vip',
            name: 'vip',
            component: () => import('@/pages/vip.vue')
        }, {
            path: '/order',
            name: 'order',
            component: () => import('@/pages/order.vue')
        }, {
            path: '/login',
            name: 'login',
            component: () => import('@/pages/login.vue')
        }, {
            path: '/register',
            name: 'register',
            component: () => import('@/pages/register.vue')
        }, {
            path: '/messageForCode',
            name: 'messageForCode',
            component: () => import('@/pages/messageForCode.vue')
        }, {
            path: '/details',
            name: 'details',
            component: () => import('@/pages/details.vue')
        }, {
            path: '/purchase',
            name: 'purchase',
            component: () => import('@/pages/purchase.vue')
        },
    ]
})

export default router;
